import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Tab, Tabs, Typography } from '@mui/material';
import { ReceiptLongOutlined, AccountBalanceWalletOutlined, HistoryOutlined } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import TransactionReportCards from './TransactionReportCards';
import ReceiptsList from './ReceiptsList';
import SettlementList from './SettlementList';
import './transactions.css';

const TransactionsList = () => {
  const [params, setParams] = useSearchParams();
  const tab = ['1', '2'].includes(params.get('id')) ? Number(params.get('id')) : 0;
  const type = ['order', 'cocoon'].includes(params.get('type')) ? params.get('type') : params.get('type') === 'all' && tab === 0 ? 'all' : 'order';
  const update = values => {
    const next = new URLSearchParams(params);
    Object.entries(values).forEach(([key, value]) => next.set(key, String(value)));
    setParams(next);
  };
  return (
    <main className="silk-payments">
      <div className="payments-heading">
        <div><span className="payments-eyebrow">PAYMENTS WORKSPACE</span><Typography component="h1" variant="h4">Payments & settlements</Typography><p>Review receipts, manage the settlement queue, and keep track of payouts.</p></div>
        {tab !== 2 && <FormControl size="small" sx={{ minWidth: 190 }}><InputLabel id="payment-category">Payment category</InputLabel><Select labelId="payment-category" label="Payment category" value={type} onChange={event => update({ type: event.target.value })}>{tab === 0 && <MenuItem value="all">All payment receipts</MenuItem>}<MenuItem value="order">Sericulture orders</MenuItem><MenuItem value="cocoon">Cocoon payments</MenuItem></Select></FormControl>}
      </div>
      {type !== 'all' && <TransactionReportCards type={type} />}
      <Box className="payments-tabs">
        <Tabs value={tab} onChange={(_, value) => update({ id: value })} variant="scrollable" scrollButtons="auto" aria-label="Payments sections">
          <Tab id="payments-tab-0" aria-controls="payments-panel" icon={<ReceiptLongOutlined fontSize="small" />} iconPosition="start" label="Receipt review" />
          <Tab id="payments-tab-1" aria-controls="payments-panel" icon={<AccountBalanceWalletOutlined fontSize="small" />} iconPosition="start" label="Settlement queue" />
          <Tab id="payments-tab-2" aria-controls="payments-panel" icon={<HistoryOutlined fontSize="small" />} iconPosition="start" label="Payout history" />
        </Tabs>
      </Box>
      <div role="tabpanel" id="payments-panel" aria-labelledby={`payments-tab-${tab}`}>
        {tab === 1 ? <SettlementList key={type} type={type} /> : <ReceiptsList key={`${tab}-${type}`} type={tab === 2 ? 'settlement' : type === 'all' ? '' : type} history={tab === 2} />}
      </div>
    </main>
  );
};
export default TransactionsList;
